import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4">
        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 text-center md:text-left">
          {/* About Section */}
          <div>
            <h2 className="text-lg font-bold mb-4">Elikon Dairy Factory</h2>
            <p className="text-sm">
              Located in Ellopia, near Thebes, Greece, we specialize in crafting authentic feta, myzithra, crème, grill cheese, ricotta, and anthotyro using traditional methods and high-quality ingredients.
            </p>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="text-sm">
                <span className="font-semibold">Email:</span> aarapakisco@gmail.com
              </li>
              <li className="text-sm">
                <span className="font-semibold">Phone:</span> +30-6971724495
              </li>
              <li className="text-sm">
                <span className="font-semibold">Address:</span> Ellopia, Thebes, Central Greece, 32200
              </li>
            </ul>
          </div>

          {/* Google Map Embed */}
          <div>
            <h3 className="text-lg font-bold mb-4">Find Us</h3>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3132.7100762677737!2d23.109440313007408!3d38.26302967174903!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a059917009c063%3A0x564fd4973bae9b12!2sElikon%20cheese%20factory!5e0!3m2!1sel!2sgr!4v1732352432905!5m2!1sel!2sgr"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Elikon Cheese Factory Location"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8"></div>

        {/* Instagram and Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h3 className="text-lg font-bold mb-2">Follow Us</h3>
            <a
              href="https://www.instagram.com/elikon_cheese/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-400 text-sm"
            >
              Instagram
            </a>
          </div>
          <p className="text-sm">
            &copy; 2024 Elikon Dairy Products. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
